import { useState } from "react";
import { generateFullTimeline, snapToFrame } from "../utils/videoEditor/util";
export type Edit = { start: number; end: number; speed: number | string };

const FPS = 30;

export function useEdits(duration: number) {
  const [edits, setEdits] = useState<Edit[]>([]);
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const [timelineZoom, setTimelineZoom] = useState(1);

  // Ajoute un segment de 100 frames (peut adapter le speed ici)
  const addSegment = () => {
    setEdits(prev => {
      let lastEnd = 0;
      if (prev.length > 0) lastEnd = Math.max(...prev.map(s => s.end));
      const snappedStart = snapToFrame(lastEnd, FPS);
      const snappedEnd = snapToFrame(
        Math.min(lastEnd + 100 / FPS, duration),
        FPS
      );
      if (snappedStart >= duration) return prev;
      const newEdit = { start: snappedStart, end: snappedEnd, speed: 2 };
      return generateFullTimeline([...prev, newEdit], duration).filter((s: any) => s.speed !== 1);
    });
  };

  const updateEdit = (idx: number, changes: Partial<Edit>) => {
    setEdits(prev => {
      const raw = prev.map((s, i) => i === idx ? { ...s, ...changes } : s);
      return generateFullTimeline(raw, duration).filter((s: any) => s.speed !== 1);
    });
  };

  const removeEdit = (idx: number) => {
    setEdits(prev => prev.filter((_, i) => i !== idx));
    setSelectedIdx(null);
  };

  // reset tous les segments
  const resetEdits = () => setEdits([]);

  return {
    edits,
    setEdits,
    selectedIdx,
    setSelectedIdx,
    timelineZoom,
    setTimelineZoom,
    addSegment,
    updateEdit,
    removeEdit,
    resetEdits,
  };
}